class BrandDirectory extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('[data-brand-search]');
    this.brandItems = Array.from(this.querySelectorAll('[data-brand-item]'));
    this.emptyState = this.querySelector('[data-brand-empty]');
    this.resultStatus = this.querySelector('[data-brand-status]');

    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', () => this.filterBrands());
  }

  filterBrands() {
    const searchTerm = this.searchInput.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    this.brandItems.forEach((item) => {
      const brandName = item.querySelector('[data-brand-name]')?.textContent.trim().toLocaleLowerCase() || '';
      const matches = brandName.includes(searchTerm);

      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
    if (this.resultStatus) {
      this.resultStatus.textContent = `${visibleCount} ${this.dataset.resultsLabel}`;
    }
  }
}

if (!customElements.get('brand-directory')) {
  customElements.define('brand-directory', BrandDirectory);
}
